import React, { useEffect, useState } from "react";
import "./App.css";
import "./index.css";
import "./components/common_components/common_css/Common_Css.css";
import "./components/common_components/common_css/Common_Form_Css.css";

import { Route, Routes } from "react-router-dom";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import Home from "./components/home/Home";
import About_Us from "./components/about-us/About_Us";
import Privacy_Policy from "./components/privacy-policy/Privacy_Policy";
import Terms_Conditions from "./components/terms-conditions/Terms_Conditions";
import Contact_Us from "./components/contact-us/Contact_us";
import Blogs from "./components/blogs/Blogs";
import Blog_Details from "./components/blog_details/Blog_Details";
import Faq from "./components/faq/Faq";
import ScrollToTop from "./components/scrolltotop/Scroll_To_Top";
import Hospitality from "./components/hospitality/Hospitality";
import My_Profile from "./components/my_profile/My_Profile";
import My_Orders from "./components/my_profile/my_orders/My_Orders";
import Categories from "./components/categories/Categories";
import Order_details from "./components/my_profile/my_orders/order_details/Order_details";
import Delivered_order from "./components/my_profile/my_orders/delivered_order/Delivered_order";
import Cancel_order from "./components/my_profile/my_orders/cancel_order/Cancel_order";
import Cancel_order_details from "./components/my_profile/my_orders/cancel_order_details/Cancel_order_details";
import Wishlist from "./components/wishlist/Wishlist";
import Product_Description from "./components/product_description/Product_Description";
import Cart from "./components/cart/Cart";
import { useDispatch, useSelector } from "react-redux";
import Checkout from "./components/checkout/Checkout";
import SavedAddress from "./components/saved_address/SavedAddress";
import AddNewAddress from "./components/add_new_address/AddNewAddress";
import EditNewAddress from "./components/add_new_address/EditNewAddress";
import Search_Result_Page from "./components/search_result_page/Search_Result_Page";
import City_Guard from "./components/hospitality/luxury_features/city_guard/City_Guard";
import Peace_Of_Mind from "./components/hospitality/luxury_features/peace_of_mind/Peace_Of_Mind";
import Aero_Sleep_Technology from "./components/hospitality/luxury_features/aero_sleep_technology/Aero_Sleep_Technology";
import Product_Listing_Page from "./components/categories/Product_Listing_Page";
import { getAllCart, postToLoginCart } from "./features/cart/cartSlice";
import { checkTokenValidity } from "./features/auth/authSlice";
import Return_order from "./components/my_profile/my_orders/cancel_order/Return_order";
import Return_order_details from "./components/my_profile/my_orders/return_order_details/Return_order_details";
import Store_location from "./components/store-location/Store_location";
import Material from "./components/material/Material";
import WhatsappChatbot from "./components/common_components/chatbot/Chatbot";

function App() {
  const [deliveryNote, setDeliveryNote] = useState();

  const checkToken = () => {
    dispatch(checkTokenValidity());
  };
  useEffect(() => {
    checkToken();
  }, []);
  const isSignIn = useSelector((state) => state.auth.is_signin);
  const [orderAddress, setOrderAddress] = useState({});
  const [addressId, setAddressId] = useState(null);
  const [addressBillingId, setAddressBillingId] = useState(null);
  const [orderBillingAddress, setOrderBillingAddress] = useState({});
  const dispatch = useDispatch();

  useEffect(() => {
    if (isSignIn) {
      dispatch(postToLoginCart()).then(() => {
        dispatch(getAllCart(true)); // Refresh cart after merge
      });
    }
  }, [isSignIn, dispatch]);

  return (
    <>
      <ScrollToTop />
      <WhatsappChatbot/>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<About_Us />} />
        <Route path="/contact-us" element={<Contact_Us />} />
        <Route path="/privacy-policy" element={<Privacy_Policy />} />
        <Route path="/terms-conditions" element={<Terms_Conditions />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/blog/:id" element={<Blog_Details />} />
        {/* <Route path="/blog_details/:id" element={<Blog_Details />} /> */}
        <Route path="/faq" element={<Faq />} />
        <Route path="/hospitality" element={<Hospitality />} />
        <Route path="/my-profile" element={<My_Profile />} />
        <Route path="/my-orders" element={<My_Orders />} />
        <Route path="/categories" element={<Categories />} />
        <Route path="/order-details/:id" element={<Order_details />} />
        <Route path="/delivered-order/:id" element={<Delivered_order />} />
        <Route path="/cancel-order/:id" element={<Cancel_order />} />
        <Route path="/wishlist" element={<Wishlist />} />
        <Route path="/material" element={<Material />} />
        <Route
          path="/cancel-order-details/:id"
          element={<Cancel_order_details />}
        />

        <Route
          path="/return-order-details/:id"
          element={<Return_order_details />}
        />
        <Route path="/return-order/:id" element={<Return_order />} />
        <Route
          path="/product-description/:id"
          element={<Product_Description />}
        />
        <Route
          path="/cart"
          element={
            <Cart
              deliveryNote={deliveryNote}
              setDeliveryNote={setDeliveryNote}
            // // isSignIn={true}
            // orderAddress={orderAddress}
            // etOrderAddress={setOrderAddress}
            />
          }
        />

        <Route
          path="/checkout"
          element={
            <Checkout
              isSignIn={true}
              orderAddress={orderAddress}
              etOrderAddress={setOrderAddress}
              deliveryNote={deliveryNote}
              addressId={addressId}
              addressBillingId={addressBillingId}
            />
          }
        />

        <Route
          path="/saved-address"
          element={
            <SavedAddress
              addressId={addressId}
              setAddressId={setAddressId}
              orderAddress={orderAddress}
              setOrderAddress={setOrderAddress}
              setOrderBillingAddress={setOrderBillingAddress}
              orderBillingAddress={orderBillingAddress}
              addressBillingId={addressBillingId}
              setAddressBillingId={setAddressBillingId}
            />
          }
        />
        <Route
          path="/add-new-address"
          element={
            <AddNewAddress addressId={addressId} setAddressId={setAddressId} />
          }
        />

        <Route
          path="/edit-new-address/:id"
          element={
            <EditNewAddress addressId={addressId} setAddressId={setAddressId} />
          }
        />

        <Route
          path="/checkout"
          element={
            <Checkout
              deliveryNote={deliveryNote}
              setDeliveryNote={setDeliveryNote}
              addressId={addressId}
              addressBillingId={addressBillingId}
              setAddressId={setAddressId}
              orderAddress={orderAddress}
              setOrderAddress={setOrderAddress}
              orderBillingAddress={orderBillingAddress}
              isSignIn={isSignIn}
            />
          }
        />
        <Route path="/search" element={<Search_Result_Page />} />
        <Route path="/certiguard" element={<City_Guard />} />
        <Route path="/peace-of-mind" element={<Peace_Of_Mind />} />
        <Route
          path="/aero-sleep-technology"
          element={<Aero_Sleep_Technology />}
        />
        <Route path="/product-listing/:id" element={<Product_Listing_Page />} />
        <Route path="/store-location" element={<Store_location />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
